var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.846 3.23H1.154a1.154 1.154 0 1 1 0-2.307h15.692a1.154 1.154 0 1 1 0 2.308zm-6.461 6.924H1.154a1.154 1.154 0 1 1 0-2.308h9.23a1.154 1.154 0 1 1 0 2.308z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M16.846 10.154H15a1.154 1.154 0 1 1 0-2.308h1.846a1.154 1.154 0 1 1 0 2.308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.846 17.077H1.154a1.154 1.154 0 1 1 0-2.308h15.692a1.154 1.154 0 1 1 0 2.308"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgMenu;